import React from 'react';
import { Link } from 'react-router-dom';

interface DemoReportCardProps {
  report: {
    id: string;
    client_name: string;
    claimant_name: string;
    status: string;
    created_at: string;
    pdf_url?: string;
    result?: {
      final_claim_amount?: number;
    };
  };
}

export default function DemoReportCard({ report }: DemoReportCardProps) {
  const getStatusColor = (status: string) => {
    switch (status) {
      case 'completed':
        return 'bg-green-100 text-green-800';
      case 'processing':
        return 'bg-yellow-100 text-yellow-800';
      case 'causation_failed':
        return 'bg-amber-100 text-amber-800';
      case 'failed':
        return 'bg-red-100 text-red-800';
      default:
        return 'bg-gray-100 text-gray-800';
    }
  };

  return (
    <div className="border border-gray-200 rounded-lg hover:shadow-lg transition-shadow">
      <Link to={`/demo-report/${report.id}`} className="block p-4">
        <div className="flex justify-between items-start mb-3">
          <div className="flex-1">
            <h3 className="font-semibold text-lg text-gray-900 hover:text-blue-600 transition-colors">
              {report.client_name}
            </h3>
            <p className="text-sm text-gray-600">Claimant: {report.claimant_name}</p>
            <p className="text-xs text-gray-500 mt-1">
              Generated: {new Date(report.created_at).toLocaleDateString()}
            </p>
          </div>
          <div className="text-right ml-4">
            <p className="text-2xl font-bold text-blue-600">
              {report.result?.final_claim_amount
                ? `$${Number(report.result.final_claim_amount).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`
                : report.status === 'causation_failed'
                ? 'Review Needed'
                : report.status === 'processing'
                ? 'Calculating...'
                : 'Completed'}
            </p>
            <span className={`inline-block px-3 py-1 rounded-full text-xs font-semibold mt-2 ${
              report.status === 'causation_failed' 
                ? 'bg-amber-100 text-amber-800' 
                : getStatusColor(report.status)
            }`}>
              {report.status === 'causation_failed' ? 'Causation Test Failed' : report.status}
            </span>
          </div>
        </div>
      </Link>
      
      <div className="border-t px-4 py-3 bg-gray-50">
        <p className="text-xs text-gray-500 italic">
          Click to view detailed report breakdown
        </p>
      </div>
    </div>
  );
}
